// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2026 
import { Module } from 'Vuex';
import { IExtensionState, IRootState, IExtensionObject, IUrlParam } from '../../../../CommonScripts/Abstractions';
import { IExtension } from '../../../../CommonScripts/ManagerAbstractions';

const theState: IExtensionState = {
    extensions: null,
    defaultExtension: null,
    currentExtension: null
};
const extensionState: Module<IExtensionState, IRootState> = {
    namespaced: true,
    state: theState,
    mutations: {
        setExtensions(state, extensions: IExtensionObject[]) {
            state.extensions = extensions;
        },
        setDefaultExtension(state, extension: IExtensionObject) {
            state.defaultExtension = extension;
        },
        setCurrentExtension(state, extension: IExtensionObject) {
            state.currentExtension = extension;
        }
    },
    actions: {
        activateExtension(context, extensionId: string) {
            let retVal = false;
            if (context.state.extensions && context.state.extensions.length > 0) {
                const otherActiveExtensions = context.state.extensions.filter((element) => element.id !== extensionId && element.isActive);
                const theExtension = context.state.extensions.filter((element) => element.id === extensionId);
                if (otherActiveExtensions && otherActiveExtensions.length > 0) {
                    for (let count = 0; count < otherActiveExtensions.length; count++) {
                        otherActiveExtensions[count].deactivate();
                    }
                }
                if (theExtension && theExtension.length > 0 && !theExtension[0].isActive) {
                    context.commit('setCurrentExtension', theExtension[0]);
                    retVal = theExtension[0].activate();
                }
            }

            return retVal;
        },
        activateCurrent(context) {
            let retVal = false;
            if (context.state.currentExtension !== null && !context.state.currentExtension.isActive) {
                context.state.currentExtension.activate()
            }
            if (context.state.defaultExtension !== null && context.state.defaultExtension.isActive) {
                context.state.defaultExtension.deactivate();
            }
            return retVal;
        },
        activateDefault(context, keepCurrent: boolean = false) {
            if (context.state.extensions && context.state.extensions.length > 0) {
                const activeExtensions = context.state.extensions.filter((element) => element.isActive);
                for (let count = 0; count < activeExtensions.length; count++) {
                    activeExtensions[count].deactivate();
                }
            }
            if (context.state.currentExtension !== null && !keepCurrent) {
                context.commit('setCurrentExtension', null);
            }
            if (context.state.defaultExtension !== null && !context.state.defaultExtension.isActive)
                context.state.defaultExtension.activate();
            return true;
        },
        getParamsFromExtensions(context, options) {
            let params: IUrlParam[] = []
            if (context.state.extensions && context.state.extensions.length > 0) {
                for (let extension of context.state.extensions) {
                    if (extension.appendUrlParams)
                        extension.appendUrlParams(params, options);
                }
            }
            return params;
        }
    },
    getters: {
        getExtension: (state) => (id: string): IExtensionObject => {
            let retVal: IExtensionObject = null;
            if (state.extensions !== null && state.extensions.length > 0) {
                const found = state.extensions.filter((element: IExtensionObject) => element.id === id);
                retVal = found && found.length > 0 ? found[0]: null;
            }
            return retVal;
        },
        getCurrentExtension: (state): IExtensionObject => {
            return state.currentExtension;
        }
    }
}
export default extensionState;

